<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.isOnsale" @tab-click="handleFilter">
          <el-tab-pane label="出售中的商品" name="1" />
          <el-tab-pane label="仓库中的商品" name="0" />
        </el-tabs>

        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.goodsName" class="filter-item" placeholder="商品名称" />
          </el-col>
          <el-col :xs="24" :sm="9">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button class="filter-item" type="danger" icon="el-icon-edit" @click="handleCreate">上架商品</el-button>
          </el-col>
        </el-row>
      </template>

      <data-table :list="list" :page-index="queryParams.page" :limit="queryParams.limit" mall="point" @edit="handleEdit" @delete="handleRemove" />
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
  </div>
</template>

<script>
import { getGoodsList, deleteGoods } from '@/api/goods'
import Pagination from '@/components/Pagination'
import DataTable from '../components/dataTable'

export default {
  name: 'PointGoodList',
  components: { Pagination, DataTable },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        referred: 'backend',
        mallType: '1', // 积分商城
        goodsName: undefined,
        isOnsale: '1',
        page: 1,
        limit: 20
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getGoodsList(this.queryParams).then(response => {
        // console.log(response)
        this.list = response.records
        this.total = response.total
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 500)
      })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    handleCreate() {
      this.$router.push({ path: '/goods/point/create', query: { from: 'list' }})
    },
    handleEdit(evt) {
      this.$router.push({ path: `/goods/point/edit`, query: { from: 'list', id: `${evt.value}` }})
    },
    handleRemove(evt) {
      this.loading = true
      if (this.queryParams.page * this.queryParams.limit >= this.total) {
        this.queryParams = Object.assign({}, this.queryParams, { page: 1 })
      }

      const params = Object.assign({}, this.queryParams, { id: evt.value })
      deleteGoods(params).then(response => {
        this.list = response.records
        this.total = response.total
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  + .flex-tag {
    margin-top: 5px;
  }
}
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
